import { lazy, Suspense } from 'react';
import { Navigate } from 'react-router-dom';
import { PageLoader } from 'routes/PrivateRouter';
import { mappingURLs } from 'routes/mapping/mappingURLs';

import { PermissionGuard } from 'components/PermissionGuard';

// Lazy load all components
const Mapping = lazy(() =>
  import('pages/central-data-hub/mapping/Mapping').then((m) => ({
    default: m.Mapping,
  }))
);

const ProductSplitByGLAccount = lazy(() =>
  import('pages/central-data-hub/mapping/maximor-product-percent-split/ProductSplitByGLAccount').then(
    (m) => ({ default: m.ProductSplitByGLAccount })
  )
);

const MappingRouteElement = () => (
  <PermissionGuard moduleKey="mapping">
    <Suspense fallback={<PageLoader />}>
      <Mapping />
    </Suspense>
  </PermissionGuard>
);

const ProductSplitRouteElement = () => (
  <PermissionGuard moduleKey="mapping">
    <Suspense fallback={<PageLoader />}>
      <ProductSplitByGLAccount />
    </Suspense>
  </PermissionGuard>
);

export const MappingRoutes = {
  path: mappingURLs._base_relative_path,
  children: [
    {
      index: true,
      element: <Navigate to={mappingURLs.maximorDataTables} replace />,
    },
    {
      path: mappingURLs._maximorDataTables_relative_path,
      element: <MappingRouteElement />,
    },
    {
      path: mappingURLs._rawDataTables_relative_path,
      element: <MappingRouteElement />,
    },
    {
      path: 'maximor-product-percent-split',
      element: <ProductSplitRouteElement />,
    },
  ],
};
